import { useCallback } from 'react';

import { StudentViewMode } from '../../config/constants';
import { scormClient } from '../store/middleware/tracking/clients/scorm/scormTyped';

export const useExitCourse = (
  viewMode: StudentViewMode,
  onExitInterrupted?: () => void,
  isStudentHeaderHidden?: boolean
) => {
  const isBasicMode = viewMode === StudentViewMode.Basic;
  const isScorm = viewMode === StudentViewMode.Offline_SCORM || viewMode === StudentViewMode.SCORM;

  const exitCourse = useCallback(() => {
    if (isBasicMode && !isStudentHeaderHidden) {
      window.location.href = '/';
      return;
    }
    if (isScorm) {
      scormClient.quit();
      setTimeout(() => {
        try {
          scormClient.connection.isActive = false;
          window.parent.window.close();
        } finally {
          onExitInterrupted?.();
        }
      }, 200); // this is just a guess, but it should be enough to trigger the save
      return;
    }
  }, [onExitInterrupted, isScorm, isBasicMode, isStudentHeaderHidden]);

  if (isScorm || isBasicMode) {
    return exitCourse;
  }
  return undefined;
};
